const configurations = window.document.getElementById("feature_toggle.configs");
const features = JSON.parse(atob(configurations.innerText));

export function featureExists(featureName) {
    return featureName in features.features && features.groups.indexOf(features.features[featureName].group) !== -1;
}

export function groupExists(groupName) {
    return features.groups.indexOf(groupName) > -1;
}
